import React from 'react';
import './WhyUs.css';
import { FaHandshake, FaWallet, FaUserFriends, FaTags, FaStore, FaGift } from 'react-icons/fa';

const advantages = [
  {
    icon: <FaHandshake size={50} />,
    title: 'טרייד אין על כל המוניות',
    description: 'מביאים את הרכב הישן, ויוצאים עם חדש – פשוט, נוח ומשתלם.',
  },
  {
    icon: <FaWallet size={50} />,
    title: 'אפשרויות מימון',
    description: 'פתרונות מימון נוחים עם מגוון תוכניות מותאמות אישית.',
  },
  {
    icon: <FaUserFriends size={50} />,
    title: 'ליווי אישי',
    description: 'אנחנו איתך מהרגע הראשון ועד למסירה – עם שירות אנושי בגובה העיניים.',
  },
  {
    icon: <FaTags size={50} />,
    title: 'המחירים הכי משתלמים בארץ',
    description: 'השוואת מחירים מול כל הסוכנויות – אתה חוסך בלי להתאמץ.',
  },
  {
    icon: <FaStore size={50} />,
    title: 'הכל תחת קורת גג אחת',
    description: 'טרייד אין, מימון, ביטוח, אחריות – כל מה שאתה צריך במקום אחד.',
  },
  {
    icon: <FaGift size={50} />,
    title: 'הטבות לרוכשים',
    description: 'מבצעים והפתעות למצטרפים – כי מגיע לך יותר.',
  },
];

const WhyUs = () => {
  return (
    <div className="whyus-container">
      <h2 className="whyus-title">למה דווקא אנחנו?</h2>
      <div className="whyus-grid">
        {advantages.map((item, index) => (
          <div className="whyus-item" key={index}>
            <div className="whyus-icon">{item.icon}</div>
            <h3 className="whyus-heading">{item.title}</h3>
            <p className="whyus-description">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyUs;
